var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"how-to-get-page"},[_c('div',{staticClass:"container"},[_c('about-title',{attrs:{"title":_vm.t('HowToGet')}})],1),_c('map-with-directions')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }